import React from 'react';
import '../ForgotPassword/forgotPassword.scss';
import '../ResetPassword/resetPassword.scss';
import PwdReset from '../../assets/images/pwd-reset-icon.svg';
import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { VERIFY_EMAIL } from '../../gql/auth/mutation';
import { Spinner } from 'react-bootstrap';

function EmailVerified({ location, history }) {
    const [verifyEmail, { loading, error, data }] = useMutation(VERIFY_EMAIL)
    useEffect(() => {
        const verify = async () => {
            let fetcheCode = await location.search.split('=')[1]
            if (fetcheCode) {
                try {
                    await verifyEmail({
                        variables: {
                            confirmInput: {
                                confirmToken: fetcheCode
                            }
                        }
                    })

                }
                catch (e) {
                    console.error(e)
                }
            }

        }
        verify()
        // eslint-disable-next-line
    }, [])


    if (loading && !error) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '500px' }}>
            <Spinner
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
                variant='primary'
                style={{
                    width: "100px",
                    height: "100px",
                    margin: "auto",
                    display: "block"
                }} 
            />
        </div>
    }

    let errorMessage = '';
    if (error) {
        // if(error.networkError && typeof window !== 'undefined' && !window.navigator.onLine){
        //     setErrorMessage("Check Your Network, Your Browser Is Offline")
        // }
        if (error.message) {
            // setErrorMessage(error.message)
            errorMessage = error.message
        }
        // setErrorMessage("Something Went Wrong !")
        if (!error.message) {
            errorMessage = "Something Went Wrong !"
        }
    }

    const handleLogin = async () => {
        if(data?.confirmUser){
            localStorage.setItem('token', data?.confirmUser?.access_token)
            localStorage.setItem('refreshtoken', data?.confirmUser?.refresh_token)
            let user = {
                name: data?.confirmUser?.user?.firstName,
                role: data?.confirmUser?.user?.role,
                paid: data?.confirmUser?.user?.paid,
                twilioTested: data?.confirmUser?.user?.tested,
                smtpTested: data?.confirmUser?.user?.smtpTested,
                expirationDate: data?.confirmUser?.user?.expirationDate,
                twilioSaved: false,
                smtpSaved: false,
            }
            await localStorage.setItem('user', JSON.stringify(user))
            history.push('/dashboard') 
        }
    }

    return (
        <div className='forgot-password reset-password email-verified'>
            <div className="confirmation-div">
                {
                    errorMessage && <p>{errorMessage}</p>
                }
                {
                    data && (
                        <>
                            <img src={PwdReset} alt="icon" />
                            <h2>Email Verified</h2>
                            <p>Congratulations, your email has been verified. Click below to log in.</p>
                            {/* <Link className='solid-button' to='/'>Login</Link> */}
                            <button className='solid-button' style={{ padding: '15px 100px'}} onClick={handleLogin}>Login</button>
                            {/* <button className='solid-button' >Login</button> */}
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default EmailVerified
